import { t } from '../../i18n.es.js';
import React, { useState, useEffect } from 'react';
import { styled, LegacyInput } from '@teko/ds-desktop';
import { formatCurrency } from '@teko/teko-ecommerce';
import { ModalBody } from '@teko/ds-foundation';

const StyledInput = styled(LegacyInput)`
  border-radius: 4px;
  background-color: #ffffff;
  margin-bottom: 0.5em;
`;
const StyledModalBody = styled(ModalBody)`
  padding: 0;
`;
const StyledNotiText = styled.div`
  color: #82869e;
  font-size: 0.8125rem;
`;
const Row = styled.div(({ mb }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${mb || 0};
  `);
const StyledText = styled.span(({ color }) => `
  font-size: 0.8125rem;
  line-height: 1.5rem;
  font-weight: 500;
  color: ${color || "#434657"}`);
const defaultWarningText = (maxConsultationServiceFee, sellingPrice) => {
  return /* @__PURE__ */ React.createElement(StyledNotiText, null, t("\u0110\u01B0\u1EE3c ph\xE9p n\xE2ng gi\xE1 b\xE1n t\u1ED1i \u0111a"), " ", formatCurrency(maxConsultationServiceFee + sellingPrice));
};
const getStyledCurrency = (amount) => {
  const formattedCurrency = formatCurrency(amount);
  return amount >= 0 ? /* @__PURE__ */ React.createElement(StyledText, {
    color: "#2BB956"
  }, `+${formattedCurrency}`) : /* @__PURE__ */ React.createElement(StyledText, {
    color: "#E6983A"
  }, `${formattedCurrency}`);
};
const ConsultationServiceFee = ({
  maxConsultationServiceFee,
  sellingPrice,
  isShow = true,
  onChangePrice,
  defaultExpectedPrice
}) => {
  const initialWarningText = t("Gi\xE1 mu\u1ED1n b\xE1n kh\xF4ng \u0111\u01B0\u1EE3c v\u01B0\u1EE3t qu\xE1 {{var0}}", {
    var0: formatCurrency(maxConsultationServiceFee + sellingPrice)
  });
  const [showWarning, setShowWarning] = useState(false);
  const [changeAmount, setChangeAmount] = useState(0);
  const [warningText, setWarningText] = useState(initialWarningText);
  const handlePriceChange = (e) => {
    const expectedPrice2 = parseFloat(e.target.value);
    if (!!expectedPrice2 && expectedPrice2 < sellingPrice) {
      setShowWarning(true);
      setWarningText(t("Gi\xE1 mu\u1ED1n b\xE1n kh\xF4ng \u0111\u01B0\u1EE3c nh\u1ECF h\u01A1n gi\xE1 s\u1EA3n ph\u1EA9m"));
    } else if (!!expectedPrice2 && expectedPrice2 <= maxConsultationServiceFee + sellingPrice || !expectedPrice2) {
      setShowWarning(false);
    } else if (expectedPrice2 > maxConsultationServiceFee + sellingPrice) {
      setShowWarning(true);
      setWarningText(initialWarningText);
    }
    setExpectedPrice(expectedPrice2);
    setChangeAmount(expectedPrice2 - sellingPrice);
    if (onChangePrice)
      onChangePrice(e);
  };
  const [expectedPrice, setExpectedPrice] = useState(defaultExpectedPrice);
  useEffect(() => {
    setExpectedPrice(defaultExpectedPrice);
    setChangeAmount(defaultExpectedPrice - sellingPrice);
  }, [sellingPrice, defaultExpectedPrice]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledModalBody, null, /* @__PURE__ */ React.createElement(Row, {
    mb: "0.5rem"
  }, /* @__PURE__ */ React.createElement(StyledText, null, t("Gi\xE1 s\u1EA3n ph\u1EA9m")), /* @__PURE__ */ React.createElement(StyledText, null, formatCurrency(sellingPrice))), /* @__PURE__ */ React.createElement(Row, {
    mb: "0.25rem"
  }, /* @__PURE__ */ React.createElement(StyledText, null, t("Gi\xE1 mu\u1ED1n b\xE1n"))), /* @__PURE__ */ React.createElement(StyledInput, {
    placeholder: t("Nh\u1EADp s\u1ED1 ti\u1EC1n"),
    onChange: handlePriceChange,
    value: expectedPrice,
    isFocused: isShow,
    inputType: "price",
    pattern: "\\d*",
    inputMode: "numeric",
    required: true,
    currency: t("\u0111"),
    error: !!showWarning ? warningText : void 0,
    allowClear: false
  }), !showWarning && /* @__PURE__ */ React.createElement(Row, {
    mb: "0.5rem"
  }, defaultWarningText(maxConsultationServiceFee || 0, sellingPrice || 0)), /* @__PURE__ */ React.createElement(Row, {
    mb: "0.5rem"
  }, /* @__PURE__ */ React.createElement(StyledText, null, t("S\u1ED1 ti\u1EC1n ch\xEAnh:")), /* @__PURE__ */ React.createElement(StyledText, null, getStyledCurrency(changeAmount)))));
};

export { ConsultationServiceFee };
